const OfferPage = () => import('../pages/OfferPage.vue');

export default [
    {
        name: 'offer',
        path: '/offer',
        component: OfferPage,
    },
];
